<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="popupConfig.hideOnOutsideClick"
    :show-close-button="false"
    :show-title="true"
    :width="width"
    :height="height"
    :title="'Update Bin Location'"
    :wrapper-attr="wrapperAttr"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />

    <div class="css-v2 gc-popup-form" v-if="popupConfig.isPopupShow">
      <gc-form
        :key="popupConfig.formKey"
        :form-options="{
          gcLabelLocation: 'left',
        }"
        ref="gc-header-form"
        :form-items="getHeaderFormItems"
        :is-normal="true"
        :data-model="model"
        :form-mode="popupConfig.formMode"
        :from-from="'gc-header-form-d-a'"
        :form-height="popupConfig.height - 85"
        v-if="IsFormLoaded"
      />
    </div>

    <gcPopupStorageLocationList
      :popupConfig="slPopupConfig"
      :add-selected-sl-lines="addSelectedStorageLocation"
      :pre-selected-items="storageLocationLinesDataSource._array"
      v-if="slPopupConfig.visible"
    />
    <div class="footer modal-popup-footer-action-container">
      <DxButton
        text="SAVE"
        type="default"
        styling-mode="contained"
        class="save-btn-cl dx-button dx-button-mode-contained dx-button-default dx-button-has-text"
        @click="onSavePopupHandler"
        :ref="'footer-save-btn'"
        :disabled="!model.NewLocation || !model.NewLocationRecordId"
      />
      <DxButton
        text="Cancel"
        type="default"
        styling-mode="contained"
        class="dx-button dx-button-mode-contained dx-button-normal dx-button-has-text"
        @click="onCancelPopupHandler"
      />
    </div>
  </DxPopup>
</template>
<script>
import { mapGetters } from "vuex";
import gcPopupStorageLocationList from "./gc-popup-storage-location-list.vue";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ArrayStore from "devextreme/data/array_store";
import { BinLocationService } from "../_services/api/settings/products/bin-location.service";
import { ProductAttributeService } from "../_services/api/settings/products/product-attribute.service";

export default {
  mixins: [DataGridMixin],
  components: {
    gcPopupStorageLocationList,
  },
  data() {
    return {
      popupAuditVisible: false,
      model: {
        BinCardNo: null,
        SeasonYear: null,
        ProductCode: null,
        ProductDescription: null,
        CurrentLocationRecordId: null,
        CurrentLocationCode: null,
        NewLocationRecordId: null,
        NewLocationCode: null,
        NewLocation: null,
      },
      IsFormLoaded: false,
      slPopupConfig: {
        visible: false,
        dataModel: {},
      },
      locationDataSourceItems: [],
      storageLocationLinesDataSource: new ArrayStore({
        key: ["Code"],
        data: [],
      }),
      ignoreLocationChangeEvent: false,
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onToolbarMenuItemOnClick: {
      type: Function,
      default: () => {},
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 600,
    },
    dataModel: {
      type: [Object, Array],
      default: () => {},
    },
    applicationFeatureCode: {
      type: String,
      default: "WorkOrder",
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    saveCallBack: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    isBulkChange: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    this.showLoading(true);

    const binLocationDetail = this.dataModel;

    if (this.isBulkChange === false) {
      this.model.BinCardNo = binLocationDetail.BinCardNo;
      this.model.ProductCode = binLocationDetail.ProductCode;
      this.model.SeasonYear = binLocationDetail.SeasonYear;
      this.model.CurrentLocationRecordId =
        binLocationDetail.InStorageLocationRecordId;
      this.model.CurrentLocationCode = binLocationDetail.InStorageLocationCode;
      this.model.NewLocationRecordId = null;

      this.slPopupConfig.dataModel = {
        CurrentLocationRecordId: this.model.CurrentLocationRecordId,
      };
    }

    this.IsFormLoaded = true;
  },
  methods: {
    setStorageLocationLineModel() {
      this.slPopupConfig.visible = true;
    },
    addSelectedStorageLocation(selectedStorageLocationArray) {
      this.model.NewLocationRecordId = selectedStorageLocationArray[0].RecordId;
      this.model.NewLocationCode = selectedStorageLocationArray[0].Code;
      this.model.NewLocation =
        selectedStorageLocationArray[0].Code +
        " - " +
        selectedStorageLocationArray[0].Name;

      this.ignoreLocationChangeEvent = true;
    },
    releasePopupHide() {
      this.releasePopupInfo.isPopupShow = false;
    },

    /**
     * Handle Audit Popup
     */
    onAuditPopupHandler() {
      this.popupAuditVisible = !this.popupAuditVisible;
    },

    /**
     * on popup model shown
     */
    onShown() {
      // if (this.dataModel) {
      //   this.FriendlyStatus = this.dataModel.FriendlyStatus;
      // }
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
    },

    /**
     * on pop up model hide
     */
    onPopupHide() {
      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    onInitialized(e) {
      if (this.popupConfig.formMode !== "review")
        e.component.registerKeyHandler("escape", (arg) => {
          arg.stopPropagation();
        });
    },

    onEditPopupHandler() {
      this.getWorkOrderStatus();
      this.popupConfig.formMode = "edit";
      this.popupConfig.hideOnOutsideClick = false;
      this.popupConfig.formKey++;
    },

    /**
     * On Save Popup Handler
     */
    async onSavePopupHandler() {
      {
        if (this.isBulkChange) {
          const targetBinList = this.dataModel.map((item) => ({
            BinCardNo: item.BinCardNo,
            ProductCode: item.ProductCode,
            SeasonYear: item.SeasonYear,
            CurrentStorageLocationRecordId: item.InStorageLocationRecordId,
          }));

          const payload = {
            BinList: targetBinList,
            NewStorageLocationRecordId: this.model.NewLocationRecordId,
          };

          try {
            this.showLoading(true);
            await BinLocationService.updateBinLocationBulk(payload);
            this.$notify(`Bin locations updated successfully`, "success");
            this.model = {
              BinCardNo: null,
              ProductCode: null,
              SeasonYear: null,
              ProductDescription: null,
              CurrentLocationRecordId: null,
              CurrentLocationCode: null,
              NewLocationRecordId: null,
              NewLocationCode: null,
              NewLocation: null,
            };

            this.$nextTick(() => {
              this.showLoading(false);
              this.saveCallBack();
            });
          } catch (e) {
            this.saveAsDraft = false;
            this.showLoading(false);
            this.displayServerError(e, "Save Failed");
          }

          return;
        }

        const payload = {
          BinCardNo: this.model.BinCardNo,
          ProductCode: this.model.ProductCode,
          SeasonYear: this.model.SeasonYear,
          CurrentStorageLocationRecordId: this.model.CurrentLocationRecordId,
          NewStorageLocationRecordId: this.model.NewLocationRecordId,
        };

        try {
          this.showLoading(true);
          const result = await BinLocationService.updateBinLocation(payload);
          this.$notify(
            `Bin #${result.data.BinCardNo} location updated successfully`,
            "success"
          );
          this.model = {
            BinCardNo: null,
            ProductCode: null,
            SeasonYear: null,
            ProductDescription: null,
            CurrentLocationRecordId: null,
            CurrentLocationCode: null,
            NewLocationRecordId: null,
            NewLocationCode: null,
            NewLocation: null,
          };

          this.$nextTick(() => {
            this.showLoading(false);
            this.saveCallBack();
          });
        } catch (e) {
          this.saveAsDraft = false;
          this.showLoading(false);
          this.displayServerError(e, "Save Failed");
        }
      }
    },

    /**
     * on Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          }
        );
        if (confirm) {
          this.showLoading(false);
          this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
          if (this.popupConfig.formMode === "create") {
            this.popupConfig.isPopupShow = false;
          } else {
            this.popupConfig.hideOnOutsideClick = true;
            this.popupConfig.formMode = "review";
            this.popupConfig.formKey++;
            this.popupConfig.isPopupShow = false;

            // await this.resetEditedData();
          }
        }
      }
    },

    async OnNewLocationValueChanged(e) {
      if (!e.value) {
        return;
      }
      if (this.ignoreLocationChangeEvent) {
        this.ignoreLocationChangeEvent = false;
        return;
      }

      let result = await ProductAttributeService.checkStorageLocationExists(
        e.value
      );

      if (result && result.data.value.length == 0) {
        await this.$alert(
          `${e.value} is not a valid location.`,
          "Not a valid location"
        );
        const textBoxInstance =
          this.$refs["gc-header-form"].$refs["gc-form-comp"].instance.getEditor(
            "NewLocation"
          );

        textBoxInstance.focus();
      } else {
        this.addSelectedStorageLocation(result.data.value);
      }
    },
    async resetEditedData() {
      this.model.NewLocationRecordId = null;
    },

    async onCancelWorkOrderHandler() {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this work order?",
        "Cancel Work Order"
      );

      if (confirmCancel) {
        this.onCancelWorkOrder();
      }
    },

    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    updateFormValues(dataField, value) {
      const form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      form.beginUpdate();
      form.updateData(dataField, value);
      form.endUpdate();
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    vueInstance() {
      return this;
    },
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "BinCardNo",
                  label: {
                    text: "Bin Card #",
                  },
                  required: true,
                  editorOptions: {
                    rtlEnabled: false,
                    elementAttr: {
                      class: "bin-card-field",
                    },
                  },
                  visible: !this.isBulkChange,
                },

                {
                  screenField: "Product",
                  required: true,
                  displayExpr: (item) => {
                    if (item) return item.Code + " - " + item.Description1;
                    else return "";
                  },
                  visible: !this.isBulkChange,
                },
                {
                  screenField: "BinLocation",
                  label: {
                    text: "Current Location",
                  },
                  dataField: "CurrentLocationCode",
                  editorType: "dxSelectBox",
                  editorOptions: {},
                  dataSourceConfig: {
                    endpoint: "api/StorageLocationList",
                    select: ["RecordId", "Code", "Name"],
                    sort: [
                      {
                        selector: "Name",
                        asc: true,
                      },
                    ],
                  },
                  required: true,
                  displayExpr: (item) => {
                    if (item) return item.Code + " - " + item.Name;
                    else return "";
                  },
                  visible: !this.isBulkChange,
                },
                {
                  label: {
                    text: "New  Location",
                  },
                  ref: "NewLocationRef",
                  editorOptions: {
                    ref: "NewLocationRef",
                    allowUpdate: true,
                    readOnly: false,
                    onFocusIn: (e) => {
                      if (this.model.NewLocation) {
                        e.event.target.select();
                      }
                    },
                    buttons: [
                      {
                        name: "search",
                        location: "after",
                        options: {
                          icon: "search",
                          onClick: () => {
                            this.vueInstance.setStorageLocationLineModel();
                          },
                        },
                      },
                    ],
                    onValueChanged: this.OnNewLocationValueChanged.bind(this),
                  },
                  dataField: "NewLocation",
                  editorType: "dxTextBox",
                },
              ],
            },
          ],
        },
      ];
    },

    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
      ];
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          if (this.popupConfig.formMode !== "review") this.onSavePopupHandler();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-change-location {
  .status-template {
    display: flex;
    align-items: center;
  }
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .modal-popup-footer-action-container {
    padding-top: 10px;
    bottom: 0;
    margin-right: 0px;
    height: 45px;
    text-align: right;
    display: flex;
    justify-content: center;

    .save-btn-cl {
      margin-right: 10px;
      width: 120px;
    }

    .cancel-btn-cl {
      margin-right: 10px;
      width: 120px;
    }
  }

  .bin-card-field {
    input {
      text-align: left;
    }
  }
}
</style>
